module.exports = __webpack_public_path__ + "img/czechrepublic.0ec5a2b8.svg";